<template>
  <v-card class="physical-activity-progress border">
    <!-- Note: Release 2.0 scope reduction  -->
    <PAProgressTabs />
    <router-view></router-view>
  </v-card>
</template>

<script>
 import PAProgressTabs from '../../../components/Parts/PAProgressTabs.vue';

/**
 * Component PatientOverviewPAProgress.vue
 *
 * @module PatientOverviewPAProgress
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.7] app/src/APP_DASHBOARD/templates/views/Patient/PA/PatientOverviewPAProgress.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientOverviewPAProgress',
  components: {
    PAProgressTabs,
  },
};
</script>

<style lang="scss">

</style>
